import Modal from 'LuxKit/Modal/Modal'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useIntl } from 'react-intl'
import bookingProtectionGlossaryMessages from 'i18n/bookingProtectionGlossaryMessages'

interface TProps {
  remainingTime: {
    hours: number
    minutes: number
  }
}

function RemainingTimeModal({ remainingTime }: TProps) {
  const { hours, minutes } = remainingTime
  const intl = useIntl()

  const remainingTimeCopy = hours > 0
    ? intl.formatMessage(
        {
          id: 'TLlD5MTPJYKm24WEsdIS',
          defaultMessage: '{count, plural, one {# hour} other {# hours}}',
          description: 'Pluralized hours for remaining time to add cancellation protection',
        },
        { count: hours },
      )
    : intl.formatMessage(
        {
          id: '2O3bpk_Y79up61BlW7a6',
          defaultMessage: '{count, plural, one {# minute} other {# minutes}}',
          description: 'Pluralized minutes for remaining time to add cancellation protection',
        },
        { count: minutes },
      )

  const title = intl.formatMessage(bookingProtectionGlossaryMessages.cancellationProtection)

  const bodyText = intl.formatMessage(
    {
      id: 'bXr_qNeVe2qRhVw9jXjQ',
      defaultMessage: 'You have {remainingTime} to add cancellation protection. After that, it’s no longer available—this limit is set by our partner, XCover.',
      description: 'Body text explaining the time remaining to add cancellation protection',
    },
    { remainingTime: remainingTimeCopy },
  )

  return (
    <Modal title={title}>
      <BodyTextBlock variant="medium">
        {bodyText}
      </BodyTextBlock>
    </Modal>
  )
}

export default RemainingTimeModal
